@if (values.length > 0) {
	<fieldset class="c-input c-vloket-form__fieldset">
		@if (label) {
			<label class="c-input__label">
				{{ label }}
			</label>
		}
		@if (hintLabel) {
			<div class="c-input__hint">
				{{ hintLabel }}
			</div>
		}
		<fieldset class="c-vloket-form__fieldset__subset--no-spacing">
			@for (value of values; track value) {
				<cjm-radio
					[name]="groupName"
					[formControl]="form"
					[value]="value.value"
					[label]="value.label"
					[id]="value.id"
					>{{ value.label }}</cjm-radio
				>
			}
		</fieldset>
	</fieldset>
}
